import validationMessages from 'vee-validate/dist/locale/tr';
//citrix.com.tr
export default {
    privacyLinkLabel: "Gizlilik Politikamıza",
    privacyLink: '/tr-tr/about/legal/privacy/',
    privacyText: "Citrix, verilerinizi",
    privacyText2: "uygun şekilde işleyecektir",
    resetText: "Form önceden doldurulmuşsa ve dolduran kişi siz değilseniz formu sıfırlamak için lütfen",
    resetText2: "",
    resetLinkText: "buraya tıklayın.",
    yes: "Evet",
    no: "Hayır",
    submitBtn: {
        "Submit" : "Gönderin",
        "Get the eBook" : "E-kitabı edinin",
        "Watch demo" : "Watch demo",
        "Get the kit" : "Kiti edinin",
        "Request a demo": "Demo talebinde bulunun",
        "Request a call": "Sizi arayalım"
    },
    apjPrivacy:{
        title: "Kişisel Bilgilerinizi Kullanma Şeklimiz",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") yürürlükteki veri koruma yasaları ve yönetmeliklerini,",
        linkText: "Citrix Gizlilik Politikası'nı",
        part2: "uygulayarak ve erişimin kesinlikle kısıtlandığı durumlarda kişisel bilgilerinizi kullanacak ve depolayacaktır. Citrix, kişisel bilgilerinizi herhangi bir başka amaçla değil de yalnızca Gizlilik Politikası tarafından belirtilen şekilde kullanacaktır. Gizlilik Politikası gereğince Citrix, kişisel bilgilerinizin işlenmesi görevini yurt içi ya da deniz aşırı işletmelere devredebilir, kişisel bilgileri dünya genelindeki diğer Citrix ofisleri veya alt kuruluşları ile paylaşabilir ya da kişisel bilgileri yurt içi veya deniz aşırı üçüncü taraflara gönderebilir. Kişisel bilgilerinizi Citrix'e gönderdiğinizde, kişisel bilgilerinizin Citrix Gizlilik Politikası'nda açıklanan şekilde toplanması ve işlenmesini onaylamış olursunuz.",
        privacyAccept: "Yukarıdakileri ve Citrix Gizlilik Politikası'nı okudum ve onaylıyorum"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Şirket"
        },
        "department": {
            label: "Departman",
            options: [
                { value: "Application Management", text: "Uygulama Yönetimi" },
                { value: "Consulting Services", text: "Danışmanlık Hizmetleri" },
                { value: "Education / Training", text: "Eğitim / Öğretim" },
                { value: "Engineering", text: "Mühendislik" },
                { value: "Executive Office / Administration", text: "Yönetici Ofisi / İdare" },
                { value: "Finance / Accounting", text: "Finans / Muhasebe" },
                { value: "Human Resources", text: "İnsan Kaynakları" },
                { value: "Information Technology - Systems", text: "Bilgi Teknolojisi Sistemleri" },
                { value: "Legal", text: "Yasal" },
                { value: "Marketing / PR", text: "Pazarlama / Halkla İlişkiler" },
                { value: "Networking", text: "Ağ İşlemleri" },
                { value: "Operations / Manufacturing", text: "Operasyon / Üretim" },
                { value: "Pre-Sales / Technical Support", text: "Satış Öncesi / Teknik Destek" },
                { value: "Project Management", text: "Proje Yönetimi" },
                { value: "Purchasing", text: "Satın Alma" },
                { value: "Sales / Bus-Corp Development", text: "Satış / İş-Kurumsal Geliştirme" },
                { value: "Security", text: "Güvenlik" },
                { value: "Web / Online / E-Business", text: "Web / Online / E-İşletme" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Sektör",
            options: [
                { value: "E-Commerce", text: "E-Ticaret" },
                { value: "Pharmaceuticals", text: "Eczacılık" },
                { value: "Education", text: "Eğitim" },
                { value: "Entertainment", text: "Eğlence" },
                { value: "Real Estate", text: "Emlak" },
                { value: "Household Services", text: "Ev Hizmetleri" },
                { value: "Finance", text: "Finans" },
                { value: "Charitable/Non-Profit", text: "Hayır Kurumu/Kâr Amacı Gütmeyen Kurum" },
                { value: "Service Provider", text: "Hizmet Sağlayıcı" },
                { value: "Conglomerate", text: "Holding" },
                { value: "Manufacturing", text: "İmalat" },
                { value: "Business Consulting", text: "İş Danışmanlığı" },
                { value: "Utilities", text: "Kamu Hizmetleri" },
                { value: "Government/State-Province", text: "Kamu/Eyalet-Bölge" },
                { value: "Government/National-Federal", text: "Kamu/Ulusal-Federal" },
                { value: "Government/Local", text: "Kamu/Yerel" },
                { value: "Chemical Manufacturing", text: "Kimyasal Üretim" },
                { value: "Hospitality", text: "Konaklama" },
                { value: "Mining - All", text: "Madencilik -Hepsi" },
                { value: "Engineering", text: "Mühendislik" },
                { value: "Consumer Packaged Goods", text: "Paketli Tüketim Malları" },
                { value: "Retail/Wholesale", text: "Perakende/Toptancılık" },
                { value: "Personnel Services", text: "Personel Hizmetleri" },
                { value: "Oil and Gas", text: "Petrol ve Gaz" },
                { value: "Professional Services", text: "Profesyonel Hizmetler" },
                { value: "Health Care", text: "Sağlık Hizmetleri" },
                { value: "Art & Membership", text: "Sanat & Üyelik" },
                { value: "Insurance", text: "Sigorta" },
                { value: "Agriculture", text: "Tarım" },
                { value: "Transportation", text: "Taşımacılık" },
                { value: "Technology", text: "Teknoloji" },
                { value: "Telecommunication", text: "Telekomünikasyon" },
                { value: "Business/Personal Services", text: "Ticari/Kişisel Hizmetler" },
                { value: "Construction and Design", text: "Yapı ve Tasarım" },
                { value: "Legal", text: "Yasal" },
                { value: "Publishing/Printing", text: "Yayın/Baskı" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Şirketteki çalışan sayısı",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Şirketteki çalışan sayısı",
            options: [
                { value: "5,001 +", text: "5.001 +" },
                { value: "1,001 to 5,000", text: "1.001 - 5.000" },
                { value: "501 to 1,000", text: "501 - 1.000" },
                { value: "251 to 500", text: "251 - 500" },
                { value: "1 to 250", text: "1 - 250" }
            ]
        },
        "Address2": {
            label: "Adres Satırı 2"
        },
        "Address3": {
            label: "Adres Satırı 3"
        },
        "city": {
            label: "Şehir"
        },
        "country": {
            label: "Ülke"
        },
        "email": {
            label: "İş e-postası"
        },
        "firstName": {
            label: "Adı"
        },
        "lastName": {
            label: "Soyadı"
        },
        "phone": {
            label: "Telefon numarası\n"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Alan/Posta kodu"
        },
        "salutation": {
            label: "Hitap",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Eyalet/Bölge"
        },
        "address": {
            label: "Adres"
        },
        "Job_Title__c": {
            label: "İş unvanı",
            options: [
                { value: "Network Administrator / Engineer", text: "Ağ Yöneticisi / Mühendis" },
                { value: "Analyst", text: "Analist" },
                { value: "Assistant", text: "Asistan" },
                { value: "C-Level / President / VP", text: "Başkan Seviyesi / Başkan / Başkan yardımcısı" },
                { value: "IT Manager", text: "BT Müdürü" },
                { value: "Consultant", text: "Danışman" },
                { value: "Director", text: "Direktör" },
                { value: "Developer / Programmer", text: "Geliştirici / Programlayıcı" },
                { value: "Business Manager", text: "İşletme Müdürü" },
                { value: "Architect", text: "Mimar" },
                { value: "Student", text: "Öğrenci" },
                { value: "Owner / Partner", text: "Şirket Sahibi / Ortak" },
                { value: "System Administrator", text: "Sistem Yöneticisi" }
            ]
        },
        "Project_Budget__c": {
            label: "Proje bütçesi",
            options: [
                { value: "Yes", text: "Evet" },
                { value: "No", text: "Hayır" },
                { value: "Unknown", text: "Bilinmiyor" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "Birden fazla seçim yapmak için (max 5 seçim) CTRL’ye basılı tutun"
            
        },
        "Purchase_Timeframe__c": {
            label: "Satın alma zaman dilimi",
            options: [
                { value: "3 months or less", text: "3 ay veya daha az" },
                { value: "4 to 6 months", text: "4 - 6 ay" },
                { value: "7 months or more", text: "7 ay veya daha fazla" },
                { value: "No time frame", text: "Belli bir zaman yok" },
                { value: "Unknown", text: "Belirsiz" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Size e-postalar gönderebilir miyiz?",
            options: [
                { value: "Yes", text: "Evet" },
                { value: "No", text: "Hayır" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Evet" },
                { value: "No", text: "Hayır" }
            ]
        },
        "OK_to_Call__c": {
            label: "Sizi telefon ile arayabilir miyiz?",
            options: [
                { value: "Yes", text: "Evet" },
                { value: "No", text: "Hayır" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Bir satış temsilcisinin bana ulaşmasını istiyorum"
        },
        "Comments_6__c":{
            label: "Yorumlar"
        }
    },
    validation: validationMessages
}